import React, {Component} from 'react';

//import {connect} from "react-redux";
import faker from "faker";

import CsodTable from "../Csod/CsodTable";
import FormNewTrigger from "../Forms/FormNewTrigger";


class EmailAdministrationWidget extends Component {

    constructor(props) {
        super(props);
        this.state = {
            section: "System triggers",
            newTriggerFormShow: false
        };
        this.formClose = this.formClose.bind(this);
    }

    UNSAFE_componentWillMount() {
        require('../../../frontend/styles/Widgets.scss');

    }

    showSection(section) {
        this.setState({section: section});
    }

    isActive(section) {
        if (this.state.section === section) {
            return true;
        }
        return false;
    }

    getTableData() {

        let fakeData = [];
        for (let x = 0; x < 100; x++) {
            fakeData.push(
                {
                    "Action": faker.lorem.words(1),
                    "Action Type": faker.lorem.words(2),
                    "Description": faker.lorem.words(20),
                    "Options": faker.lorem.words(1),
                }
            );
        }
        return fakeData
    }

    formShow(e) {
        e.preventDefault();
        this.setState({
            newTriggerFormShow: true
        });
    }

    formClose() {
        this.setState({
            newTriggerFormShow: false
        });
    }


    render() {
    	// eslint-disable-next-line
        const {content: {contentFields}, index, htmlElementContent} = this.props;
        const {section, newTriggerFormShow} = this.state;
        // let title = "";
        // let body = "";
        // for (let x in contentFields) {
        //     if (contentFields[x].fieldDefinitionKey === "Title") {
        //         title = contentFields[x].data;
        //     }
        //     if (contentFields[x].fieldDefinitionKey === "Body") {
        //         body = contentFields[x].data;
        //     }
        // }

        const tableData = this.getTableData();

        console.table(this.state);

        return (
            <section className={"EmailAdministrationWidget EmailAdministrationWidget-" + index}>
                <section className="section-menu">
                    <ul>
                        <li className={this.isActive("System triggers") ? "active" : ""}><a
                            onClick={(e) => this.showSection("System triggers")}>System triggers</a>
                        </li>
                        <li className={this.isActive("Custom date triggers") ? "active" : ""}><a
                            onClick={(e) => this.showSection("Custom date triggers")}>Custom date triggers</a>
                        </li>
                    </ul>
                </section>
                <section className={"section-content"}>
                    {this.isActive("Custom date triggers") &&
                    <div className="widgetDefault--inner">
                        <div className={"cso-main-cont cso-cont-pad20"}>
                            <button className="button-row cso-btn cso-action cso-corner cso-btn-grey"
                                    onClick={(e) => this.formShow(e)}>{"New Trigger"}</button>
                            <CsodTable data={tableData}/>
                            {newTriggerFormShow &&
                            <FormNewTrigger onClose={this.formClose}/>
                            }
                        </div>
                    </div>
                    }

                    {this.isActive("System triggers") &&
                    <div className="widgetDefault--inner">
                        <div dangerouslySetInnerHTML={{__html: htmlElementContent}}>
                        </div>
                    </div>
                    }
                </section>
            </section>
        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         version: state.layout.version,
//     };
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         setVersion: () => dispatch(setVersion()),
//     };
// };

//Widget = connect(mapStateToProps, mapDispatchToProps)(FrontLayout)

export default EmailAdministrationWidget;



// WEBPACK FOOTER //
// ./src/widgets/components/Widgets/EmailAdministrationWidget.js